/**
 * Utility functions for extracting data from entity metadata schemas
 */

/**
 * Extracts timezone options from the resolved schema
 */
export function extractTimezoneOptions(
  metadataWithSchema: { data?: Record<string, unknown> } | undefined
): string[] {
  if (!metadataWithSchema?.data) {
    return [];
  }

  const resolvedSchema = metadataWithSchema.data.resolvedSchema as
    | Record<string, unknown>
    | undefined;
  if (!resolvedSchema) {
    return [];
  }

  const properties = resolvedSchema.properties as
    | Record<string, unknown>
    | undefined;
  const preferences = properties?.preferences as
    | Record<string, unknown>
    | undefined;
  const preferencesProps = preferences?.properties as
    | Record<string, unknown>
    | undefined;
  const timezoneField = preferencesProps?.timezone as
    | Record<string, unknown>
    | undefined;

  return (timezoneField?.enum as string[]) || [];
}

/**
 * Extracts locale options from the resolved schema
 */
export function extractLocaleOptions(
  metadataWithSchema: { data?: Record<string, unknown> } | undefined
): string[] {
  if (!metadataWithSchema?.data) {
    return [];
  }

  const resolvedSchema = metadataWithSchema.data.resolvedSchema as
    | Record<string, unknown>
    | undefined;
  if (!resolvedSchema) {
    return [];
  }

  const properties = resolvedSchema.properties as
    | Record<string, unknown>
    | undefined;
  const preferences = properties?.preferences as
    | Record<string, unknown>
    | undefined;
  const preferencesProps = preferences?.properties as
    | Record<string, unknown>
    | undefined;
  const localeField = preferencesProps?.localeIdentifier as
    | Record<string, unknown>
    | undefined;

  return (localeField?.enum as string[]) || [];
}

/**
 * Gets the default timezone for the current user's browser
 */
export function getDefaultTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

/**
 * Gets the default locale for the current user's browser
 */
export function getDefaultLocale(): string {
  return navigator.language || 'en-US';
}
